import Icon from "@builder/components/general/Icon";
import "./style.scss";
import classNames from "classnames";

interface SimpleCheckboxProps {
    label: string;
    checked?: boolean;
    value: string;
    disabled?: boolean;
    callback: (value: string, checked: boolean) => void;
    custom?: boolean;
}

const SimpleCheckbox = ({ label, checked, value, disabled, callback, custom = true }: SimpleCheckboxProps) => {
    const handleCheck = (e: React.FormEvent<HTMLInputElement>) => {
        callback(e.currentTarget.value, e.currentTarget.checked);
    };

    return (
        <label className={classNames("simple-checkbox-wrapper", { "checkbox-disabled": disabled })}>
            <input type="checkbox" value={value} checked={checked} disabled={disabled} onChange={handleCheck} />
            {custom ? (
                <div className="custom-checkbox">
                    {checked && <Icon src="./blue-checkmark.svg" className="checkbox-checkmark" />}
                </div>
            ) : (
                <div className="custom-checkbox-plain">{checked && <div className="plain-checkbox" />}</div>
            )}
            {label}
        </label>
    );
};

export default SimpleCheckbox;
